import { createGlobalStyle } from "styled-components";

export const theme = {
  colors: {
    brand: {
      light: "#8A5CFF",
      normal: "#5C26FF",
      dark: "#4A1ECC",
    },
    secondary: {
      blue: {
        normal: "#D7E3FF",
        light: "#EEF2FF",
      },
    },
    greyscale: {
      black: "#111827",
      gray100: "#1F2937",
      gray80: "#4B5563",
      gray60: "#9CA3AF",
      gray40: "#D1D5DB",
      gray20: "#E5E7EB",
      gray10: "#F3F4F6",
      gray00: "#F9FAFB",
      white: "#FFFFFF",
    },
    alert: {
      green: "#10B981",
      orange: "#F59E0BEE",
      red: "#EE4549",
      blue: "#3B82F6",
    },
  },
} as const;

export type ThemeType = typeof theme;

export const GlobalStyle = createGlobalStyle`
  * {
    font-family: Outfit !important;
  }
   .mantine-InputWrapper-label {
    font-size: 16px;
    margin-bottom: 8px;
  }
  .mantine-Input-input {
    height: 44px !important;
    width: 100% !important;
    border-radius: 6px;
    border-color: #D1D5DB;
    border-width: 1px;

    &::placeholder {
      color: ${theme.colors.greyscale.gray60};
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
    }
    &:focus {
      border-color: ${theme.colors.brand.normal};
      box-shadow: 0px 0px 5px 3px #5C26FF14;
    }
    &[data-disabled="true"] {
      background-color: #F9FAFB;
      color: black;
      cursor: not-allowed;
      opacity: 1;
    }
    &[data-error="true"] {
     border-color: ${theme.colors.alert.red}
    }
  }
  .mantine-Select-input {
    cursor: pointer;
  }
  .mantine-InputPlaceholder-placeholder {
    color: ${theme.colors.greyscale.gray60};
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }
  
  .mantine-Menu-item {
    font-size: 16px;
  }
`;
